import { render, staticRenderFns } from "./Ornament.vue?vue&type=template&id=195e3e68&scoped=true&"
import script from "./Ornament.vue?vue&type=script&lang=js&"
export * from "./Ornament.vue?vue&type=script&lang=js&"
import style0 from "./Ornament.vue?vue&type=style&index=0&id=195e3e68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e3e68",
  null
  
)

export default component.exports